import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "customer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Price List", -1)

import { computed } from 'vue';
import { useStore } from 'vuex';
import DocumentsComponent from "@/components/document/Documents.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PriceList',
  setup(__props) {

const store = useStore();
const customer = computed(() => store.getters['customers/current']);
const getPricelistDocs = computed(() => customer.value.pricelist);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(), _createBlock(DocumentsComponent, {
      key: getPricelistDocs.value.length,
      documents: getPricelistDocs.value,
      path: 'pricelist'
    }, null, 8, ["documents"]))
  ]))
}
}

})